const OPTIMIZED_ASSET_VERSION = '20260313a';

const appendVersionQuery = (url: string) => {
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}ov=${OPTIMIZED_ASSET_VERSION}`;
};

export const toWebpVariantUrl = (url?: string | null): string | null => {
  if (!url || typeof url !== 'string') return null;
  if (/\.webp(?=([?#]|$))/i.test(url)) return appendVersionQuery(url);
  if (!/\.(png|jpe?g)(?=([?#]|$))/i.test(url)) return null;
  return appendVersionQuery(url.replace(/\.(png|jpe?g)(?=([?#]|$))/i, '.webp'));
};
